import { render, staticRenderFns } from "./area-table-list.vue?vue&type=template&id=a2e09066&scoped=true"
import script from "./area-table-list.vue?vue&type=script&lang=js"
export * from "./area-table-list.vue?vue&type=script&lang=js"
import style0 from "./area-table-list.vue?vue&type=style&index=0&id=a2e09066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e09066",
  null
  
)

export default component.exports